export default "__VITE_ASSET__CsXgGa9b__"